import { render, staticRenderFns } from "./ExperienceSub.vue?vue&type=template&id=518c50d0&"
import script from "./ExperienceSub.vue?vue&type=script&lang=js&"
export * from "./ExperienceSub.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceSub.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports